module.exports = __webpack_public_path__ + "img/about-introduce-right.a0552d9e.png";